export default __webpack_public_path__ + "90e4d7993f53af0de95adba94cfe3320.svg";